<template>
  <div>
    <div class="page-header">
      <h3 class="capitalize">Today</h3>
    </div>
    <TaskExpander />
    <NewQuickTask :dueDate="new Date()"/>

    <ul class="mt-2 list-group">
      <draggable v-model="allTasks" @start="drag=true" @end="drag=false" handle=".sort-handle">
        <transition-group type="transition" :name="'flip-list'">
          <li v-for="task in allTasks" :key="task.id" class="list-group-item js-task-details-collapse-container">
            <QuickTask :task="task" :sortable=true />
          </li>
        </transition-group>
      </draggable>
    </ul>
  </div>
</template>

<script>
var firstBy = require('thenby');
import api from "api";
import QuickTask from "components/QuickTask";
import NewQuickTask from "components/NewQuickTask";
import TaskExpander from "components/TaskExpander";
import draggable from 'vuedraggable'

export default {
  components: {
    QuickTask,
    NewQuickTask,
    TaskExpander,
    draggable
  },
  data() {
    return {
      hideComletedTasks: true
    };
  },    
  computed: {
    allTasks: { 
      set: function(value){
        var ordered_ids = []
        value.forEach(function(item, index){
          ordered_ids.push(item.id)
        })

        var payload = {
          name: 'today',
          ordered_ids: ordered_ids
        }
        store.commit('updateSortedGroup', payload)

        return value;
      },
      get: function(){
        return store.getters.sortedTodayTasks(this.hideComletedTasks)
      }
    }
  }
};
</script>
